import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyCompanionButton = ({
  additionalTracking,
  displayAICompanion,
  handleAICompanionClick
}) => {
  useEffect(() => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({
      action: 'ai-quiz-me-button-rendered'
    }, additionalTracking));
  }, [additionalTracking]);
  return /*#__PURE__*/_jsxs(AIButton, {
    onClick: handleAICompanionClick,
    usageTracker: UsageTracker.tracker,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.interactiveEducation.quiz.quizMeTitle"
    }), displayAICompanion ? /*#__PURE__*/_jsx(UpIcon, {
      alignWithText: true
    }) : /*#__PURE__*/_jsx(DownIcon, {
      alignWithText: true
    })]
  });
};
export default AcademyCompanionButton;